import { styled } from '@mui/material/styles'

const Wrapper = styled('button')((props) => ({
  'display': 'block',
  'position': 'relative',
  'overflow': 'hidden',
  'margin': 0,
  'padding': 0,
  'width': '34px',
  'height': '34px',
  'fontSize': 0,
  'textIndent': '-9999px',
  'appearance': 'none',
  'boxShadow': 'none',
  'borderRadius': '50%',
  'border': 'none',
  'cursor': 'pointer',
  'transition': 'background 0.2s ease-in-out',
  'background': props.isToggled ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
  '&:focus': {
    background: 'rgba(255, 255, 255, 0.2)',
  },
}))

const Toggle = styled('span')((props) => ({
  'display': 'block',
  'position': 'absolute',
  'top': '16px',
  'left': '7px',
  'right': '7px',
  'height': '2px',
  'background': props.color,
  'transition': 'transform 0.3s',
  'transform': props.isToggled ? 'rotate(180deg)' : null,
  '&:before, &:after': {
    position: 'absolute',
    display: 'block',
    left: 0,
    width: props.isToggled ? '50%' : '100%',
    height: '2px',
    backgroundColor: props.color,
    content: '""',
  },
  '&:before': {
    transformOrigin: 'top right',
    transition: 'transform 0.3s, width 0.3s, top 0.3s',
    top: props.isToggled ? '0' : '-5px',
    transform: props.isToggled
      ? 'translateX(13px) translateY(1px) rotate(45deg)'
      : null,
  },
  '&:after': {
    transformOrigin: 'bottom right',
    transition: 'transform 0.3s, width 0.3s, bottom 0.3s',
    bottom: props.isToggled ? '0' : '-5px',
    transform: props.isToggled
      ? 'translateX(13px) translateY(-1px) rotate(-45deg)'
      : null,
  },
}))

function HamburgerMenu(props) {
  const handleClick = () => {
    props.toggleSideNav()
  }

  return (
    <Wrapper isToggled={props.isToggled} onClick={() => handleClick()}>
      <Toggle color={props.color} isToggled={props.isToggled} />
    </Wrapper>
  )
}

HamburgerMenu.defaultProps = {
  color: 'white',
  isToggled: false,
  toggleSideNav: () => {},
}

export default HamburgerMenu
